import React from 'react'
import uuid from 'uuid'
import WPBlock from '../../components/WPBlock'

const SectionCallout = ({ block }) => {
  if (!block || !block.innerBlocks) {
    return null
  }

  const bgColor = block.attrs['background_color'] || '#363636'

  return (
    <section className="section" style={{ backgroundColor: bgColor }}>
      <div className="container content">
        {block.innerBlocks.map(innerBlock => {
          const key = uuid.v4()

          return <WPBlock key={key} block={innerBlock} />
        })}
      </div>
    </section>
  )
}

export default SectionCallout
